import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class IdentityDocuments extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_emp_basic_details.bind(this)}>Update</button>,
      downloads_div:'',
    };
  }


  componentDidMount(){
    this.get_emp_basic_details();
  }
  get_emp_basic_details(){
      var cutThis           = this;
      var emp_id            = cutThis.props.id;
      var web_token         = window.isNullAndUndef($('#web_token').val());
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('web_token',web_token);
      body.append('form_type','employee_identity_and_verification_documents');
      body.append('function','get_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          if(data['error']==1){
            var new_data = data['data'];
            cutThis.update_info(new_data);
            cutThis.downloads_files(data);
          }

       })
       .catch(function (error) {
           console.log(error);
       });
  }

  downloads_files(data){
    var emp_id  = data['emp_id'];
    var file_id = data['id'];
    var downloads_div = [];
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'aadhar_card')}><i class="fas fa-file-download"></i> Aadhaar Card</a></div>);
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'credit_report')}><i class="fas fa-file-download"></i> Credit report</a></div>);
    this.setState({downloads_div});
  }

  check_download_file(file_id,emp_id,file_name){
    var web_token         = window.isNullAndUndef($('#web_token').val());
    var form_type         = 'employee_identity_and_verification_documents';
    var url = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_download_employee_files_url.php";
    }else{
      url = "/php/admin_download_employee_files_url.php";
    }
    var new_str = '?emp_id='+emp_id+"&file_id="+file_id+'&file_name='+file_name+"&function=check_download_emp_file&form_type="+form_type+"&web_token="+web_token;
    window.open(url+new_str, '_blank');
  }

  update_info(data){
    $('#old_aadhar_card').val(data['aadhar_card_new_name']);
    $('#pan_number').val(data['pan_number']);
    $('#old_credit_report').val(data['credit_report_new_name']);
  }

  add_emp_basic_details(){
    var file_main_ext       = ['png','jpg','jpeg','JPEG','JPG','PNG'];
    var cutThis             = this;
    var emp_id              = cutThis.props.id;
    var web_token           = window.isNullAndUndef($('#web_token').val());

    var pan_number          = window.isNullAndUndef($('#pan_number').val());
    var aadhar_card_temp    = window.isNullAndUndef($('#aadhar_card').val());
    var credit_report_temp  = window.isNullAndUndef($('#credit_report').val());
    var org_aadhar_card     = $("#aadhar_card").prop("files")[0];
    var aadhar_card_name    = $('#aadhar_card').val().split('\\').pop();
    var org_credit_report   = $("#credit_report").prop("files")[0];
    var credit_report_name  = $('#credit_report').val().split('\\').pop();


    var aadhar_card_ext    = '';
    var credit_report_ext  = '';

    if(aadhar_card_temp && credit_report_temp){
      aadhar_card_ext      = aadhar_card_temp.split('.').pop();
      credit_report_ext    = credit_report_temp.split('.').pop();
    }

    var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">Update...</button>;
    cutThis.setState({submit_button});
    $('label').removeClass('color_red');
    if(aadhar_card_temp && pan_number && credit_report_temp && file_main_ext.indexOf(aadhar_card_ext) >= 0 && file_main_ext.indexOf(credit_report_ext) >= 0){
      var old_aadhar_card     = $('#old_aadhar_card').val();
      var old_credit_report   = $('#old_credit_report').val();
      var all_data                    = {};
      all_data['aadhar_card']         = window.return_false_null(aadhar_card_name);
      all_data['pan_number']          = window.return_false_null(pan_number);
      all_data['credit_report']       = window.return_false_null(credit_report_name);
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('aadhar_card_file',org_aadhar_card);
      body.append('credit_report_file',org_credit_report);
      body.append('old_aadhar_card',old_aadhar_card);
      body.append('old_credit_report',old_credit_report);
      body.append('emp_date',JSON.stringify(all_data));
      body.append('web_token',web_token);
      body.append('form_type','employee_identity_and_verification_documents');
      body.append('function','add_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           async: false,
           data: body,
           enctype: 'multipart/form-data',
           processData: false,
           contentType: false,
           cache: false,
       })
       .then(function (res) {
          var data = res.data;
          $('#error_msg').text(data['msg']);
          submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
          cutThis.setState({submit_button});
          cutThis.get_emp_basic_details();
       })
       .catch(function (error) {
           console.log(error);
       });
    }else {
      window.change_lable_color('aadhar_card','pan_number','credit_report');
      submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
      cutThis.setState({submit_button});
    }

  }


  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_aadhar_card" placeholder="Aadhaar Card"/>
                                        <input type="file" className="form-control" id="aadhar_card" placeholder="Aadhaar Card"/>
                                        <label for="name">Aadhaar Card</label>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="pan_number" placeholder="PAN Card"/>
                                        <label for="name">PAN Card</label>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_credit_report" placeholder="Credit report"/>
                                        <input type="file" className="form-control" id="credit_report" placeholder="Credit report"/>
                                        <label for="name">Credit report</label>
                                    </div>
                                </div>


                                <div className="col-md-12">
                                    <div className="col-md-4">
                                      <p id="error_msg"></p>
                                    </div>
                                    <div className="col-md-4">
                                      <p># Form upload, only allow PNG, JPEG & JPG</p>
                                    </div>
                                    <div className="col-md-4 p-0 float_r">
                                        {this.state.submit_button}
                                    </div>
                                </div>
                                {this.state.downloads_div}

                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default IdentityDocuments;
